import { render, staticRenderFns } from "./CommitteeAdd.vue?vue&type=template&id=62519f18"
import script from "./CommitteeAdd.vue?vue&type=script&lang=js"
export * from "./CommitteeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports